import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { firebaseDatabaseUrl } from '../../utils/firebase';
import { useLanguage } from '../../context/LanguageContext';
import LanguageSwitcher from '../LanguageSwitcher';

const navClass = ({ isActive }) =>
  `flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition ${
    isActive
      ? 'bg-brand-500/15 text-brand-200 ring-1 ring-brand-500/25'
      : 'text-slate-400 hover:bg-slate-800/80 hover:text-slate-200'
  }`;

const AdminDashboard = () => {
  const { user } = useAuth();
  const { language } = useLanguage();
  const isFr = language === 'fr';
  const t = (frText, enText) => (isFr ? frText : enText);
  const { pathname } = useLocation();
  const usersSectionActive = pathname === '/admin' || pathname.startsWith('/admin/users');

  return (
    <div className="flex min-h-screen bg-slate-950 text-slate-100">
      <aside className="flex w-64 shrink-0 flex-col border-r border-slate-800/80 bg-slate-900/50">
        <div className="border-b border-slate-800/80 p-5">
          <p className="text-xs font-semibold uppercase tracking-wider text-brand-400/90">{t('Console', 'Console')}</p>
          <h1 className="mt-1 text-lg font-bold tracking-tight text-white">{t('Administration', 'Administration')}</h1>
          <div className="mt-3">
            <LanguageSwitcher />
          </div>
        </div>
        <nav className="flex flex-1 flex-col gap-1 p-3">
          <NavLink to="/admin/users" className={() => navClass({ isActive: usersSectionActive })}>
            {t('Utilisateurs inscrits', 'Registered users')}
          </NavLink>
          <NavLink to="/admin/events" className={navClass}>
            {t('Événements', 'Events')}
          </NavLink>
        </nav>
        {user ? (
          <div className="mt-auto space-y-2 border-t border-slate-800/80 p-4 text-xs text-slate-500">
            <p className="font-medium text-slate-400">{t('Connecté', 'Signed in')}</p>
            <p className="break-all text-slate-300">{user.email || '—'}</p>
            <p className="pt-2 font-medium text-slate-500">Auth UID</p>
            <p className="break-all font-mono text-[11px] leading-relaxed text-slate-400">{user.uid}</p>
            <p className="pt-2 font-medium text-slate-500">{t('Base de données temps réel', 'Realtime Database')}</p>
            <p className="break-all font-mono text-[11px] text-slate-500">{firebaseDatabaseUrl}</p>
            <p className="border-t border-slate-800/80 pt-3 leading-snug text-amber-200/85">
              {t('Collez ', 'Paste ')}
              <code className="rounded bg-slate-950 px-1 py-0.5 text-amber-100">database.rules.json</code>
              {t(' dans les règles Firebase puis publiez.', ' into Firebase Rules and publish.')}
            </p>
          </div>
        ) : null}
      </aside>

      <main className="min-w-0 flex-1 overflow-auto bg-slate-950 bg-mesh-gradient p-6 sm:p-8 lg:p-10">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminDashboard;
